// extracted by mini-css-extract-plugin
export default {"root":"Body_root__Biu1R"};